import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useCart } from "@/lib/cart";

export default function ShopSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clear } = useCart();
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          clear();
          setState("paid");
          return;
        }
      } catch { /* keep polling */ }
      attempts += 1;
      if (attempts < 15) setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col items-center justify-center px-6 text-center" data-testid="payment-success-page">
      <div className="h-px w-16 bg-[#C5A059] mb-8" />
      {state === "paid" && (
        <>
          <h1 className="font-serif text-4xl md:text-5xl font-light mb-4">Thank you.</h1>
          <p className="text-base text-[#4A4A4A] mb-2">Your payment was successful and your order is confirmed.</p>
          <p className="text-sm text-[#4A4A4A] mb-10">You'll receive an email when it ships.</p>
        </>
      )}
      {state === "checking" && (
        <>
          <h1 className="font-serif text-4xl md:text-5xl font-light mb-4">Confirming…</h1>
          <p className="text-sm text-[#4A4A4A]">We're confirming your payment with Stripe.</p>
        </>
      )}
      {(state === "timeout" || state === "error") && (
        <>
          <h1 className="font-serif text-4xl md:text-5xl font-light mb-4">Almost there.</h1>
          <p className="text-sm text-[#4A4A4A] mb-10">
            We couldn't confirm your payment yet. If you were charged, your order is safe — contact us and we'll sort it out.
          </p>
        </>
      )}
      <Link to="/shop" data-testid="success-continue-link"
        className="text-xs tracking-[0.25em] uppercase border border-[#1A1A1A] px-8 py-3.5 hover:bg-[#1A1A1A] hover:text-white transition-colors duration-300">
        Back to Shop
      </Link>
    </div>
  );
}
